import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { MicrosoftLogin, ProcessToken } from "../../actions/Signin";
import { useToastController, Toast, ToastBody, ToastTitle } from "@fluentui/react-components";
import ScholarSiftLogin from "./ScholarSiftLogin";
import creds from "../../creds.json";
import useUser from "../../hooks/useUser";
import useLocationState from "../../hooks/useLocationState";
import ViewPort from "../Layout/ViewPort";
import { Debug, ssToast } from "ss-lib";
import "./Auth.scss";

const TopMargin = 70;

const SignIn = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, currentUser, saveUser, setTitle } = useUser();
  const { dispatch, state } = useLocationState();
  const [doRedirect, setDoRedirect] = useState(false);
  const [createMode, setCreateMode] = useState(location.pathname === "/signin/create");
  const h = useRef();
  const { dispatchToast } = useToastController(ssToast);

  useEffect(() => {
    document.title = createMode ?
      "ScholarSift - Sign Up" :
      "ScholarSift - Sign In";

    setTitle(createMode ?
      "Sign Up" :
      "Sign In"
    )

    const initializeGsi = () => {
      function handleGoogleSignIn(response) {
        const token = response.credential;
       // localStorage.clear();
        ProcessToken(token, user, "Google", saveUser, finishLogin, showLoader);
      }

      var cid = creds.googleClientId[window.location.hostname];

      window.google.accounts.id.initialize({
        client_id: cid,
        callback: handleGoogleSignIn,
        context: createMode ? "signup" : "signin"
      });

      window.google.accounts.id.renderButton(
        document.getElementById("google-sign-in"),
        { theme: "filled_blue", size: "large", width: 200 , text: createMode ? "signup_with" : "signin_with"}
      );
    };

    let scriptCheck = document.getElementById("gsi-script");
    if (scriptCheck === null) {
      const script = document.createElement("script");
      script.src = "https://accounts.google.com/gsi/client";
      script.onload = initializeGsi;
      script.async = true;
      script.defer = true;
      script.id = "gsi-script";
      document.querySelector("body")?.appendChild(script);
    }
    else {
      window.google.accounts.id.renderButton(
        document.getElementById("google-sign-in"),
        { theme: "filled_blue", size: "large", width: 200 , text: createMode ? "signup_with" : "signin_with"}
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createMode]);

  useEffect(() => {
    let v = state.viewport.h - (state.viewport.m + state.viewport.f);
    if (v !== h.current) h.current = v;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.viewport]);

  useEffect(() => {
    if (
      location &&
      location.path &&
      location.path !== "/signin" &&
      currentUser.scholarsift.profile
    )
      setDoRedirect(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  const setError = (v) => {
    if (
      (typeof v === "string" || v instanceof String) &&
      v.indexOf("not authorized for beta access") > -1
    )
      v = (
        <div>
          {v} Please contact
          <a href="mailto:inquiries@scholarsift.com">
            inquiries@scholarsift.com
          </a>{" "}
          for access.
        </div>
      );
    dispatch({ type: "message-update", key: "error", payload: undefined });
    dispatch({ type: "message-update", key: "error", payload: v });
  };

  const showLoader = (v) => {
    dispatchToast(<Toast appearance='inverted'><ToastTitle>Logged In</ToastTitle><ToastBody>{v}</ToastBody></Toast>, {intent: "information"})
  };

  const finishLogin = (v) => {
    if(Debug()) console.log("Finish Login:");
    if(Debug()) console.log(v);

    if (!v) return;

    if (v.scholarsift) v = { ...v.scholarsift, subscribe: v.subscribe };

    setError(undefined);
    dispatch({
      type: "message-update",
      key: "mandatory",
      payload: v.mandatory,
    });
    dispatch({ type: "message-update", key: "role", payload: v.role });

    if(Debug()) console.log("Pushing onto navigate:");
    if(Debug()) console.log(
      location.state && location.state.location
        ? location.state.location
        : v.defaultURL
          ? v.defaultURL : "/welcome"
    );

    navigate(
      location.state && location.state.location
        ? location.state.location
        : v.defaultURL
          ? v.defaultURL : "/welcome"
    );
  };

  const msftClick = () => {
    localStorage.clear();
    dispatch({ type: "reset" });
    MicrosoftLogin(user, saveUser, finishLogin, showLoader, setError);
  };

  if (doRedirect && location.path && location.path !== "signin")
    navigate(location.path, { state: { u: currentUser } });


  console.log(state.viewport);
  
  return (
    <ViewPort>
      <div
        style={{
          marginTop: state.viewport.h > 700 ? TopMargin : undefined,
          minHeight:
            state.viewport.h -
            (state.viewport.m +
              state.viewport.f +
              (state.viewport.h > 700 ? TopMargin : 0)),
        }}
      >
        <div className="signin-panel">
          <div className="signin-block">
            <svg
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              x={0}
              y={0}
              viewBox="0 0 720 233.8"
              style={{
                enableBackground: "new 0 0 720 233.8",
              }}
              xmlSpace="preserve"
              {...props}
            >
              <style>{".st1{fill:#648af1}.st3{fill:#fff}"}</style>
              <path
                className="st1"
                d="m128.6 146.3-18.3 6.9 42.7 16.2 42.6-16.2-18.2-6.9-24.4 9.2z"
              />
              <path
                className="st2"
                d="m187.2 120.8-34.2 13-.7-.2-33.5-12.8-23.3 8.9 57.5 21.8 57.5-21.8z"
              />
              <path
                className="st3"
                d="m153 76.4-70.5 26.8 70.5 26.7 70.4-26.7zM274.8 121c-1.6-1.2-3.3-2.3-5.1-3.1-1.9-.8-3.7-1.5-5.6-2.2-1.9-.6-3.6-1.3-5.2-2s-2.8-1.5-3.8-2.5c-1-.9-1.4-2.2-1.4-3.7 0-1.7.7-3.1 2.1-4.1 1.4-1 3.4-1.5 5.9-1.5 2.2 0 4.1.4 5.8 1.3 1.7.8 3.4 2.2 5 4l7.1-7.1c-1.9-2.3-4.4-4.1-7.5-5.6-3.1-1.4-6.5-2.1-10.3-2.1-3.6 0-6.8.6-9.7 1.9-2.9 1.3-5.1 3.1-6.7 5.5-1.6 2.4-2.5 5.3-2.5 8.6 0 2.9.5 5.3 1.4 7.1.9 1.9 2.2 3.4 3.8 4.6 1.6 1.2 3.3 2.2 5.2 3 1.9.8 3.7 1.5 5.6 2.1 1.9.6 3.6 1.3 5.2 2s2.8 1.6 3.8 2.7 1.4 2.4 1.4 4.1c0 2-.8 3.5-2.5 4.6-1.6 1.1-3.9 1.7-6.7 1.7-3.1 0-5.7-.6-7.9-1.8-2.1-1.2-4.1-2.9-5.7-5l-7.1 7.1c2.6 3.1 5.5 5.4 8.7 7 3.2 1.5 7 2.3 11.5 2.3 6.4 0 11.4-1.5 15.1-4.5 3.6-3 5.5-7.1 5.5-12.2 0-2.9-.5-5.4-1.4-7.3-1.2-2-2.4-3.6-4-4.9zM300 121c1.5-.9 3.2-1.3 5.1-1.3 1.7 0 3.2.3 4.6.9 1.4.6 2.6 1.5 3.5 2.6l6.8-6.8c-1.9-2.1-4.1-3.7-6.7-4.8-2.5-1.1-5.3-1.6-8.3-1.6-3.9 0-7.4.9-10.5 2.6-3.1 1.7-5.6 4.1-7.4 7.2-1.8 3-2.7 6.5-2.7 10.3 0 3.7.9 7.1 2.7 10.1 1.8 3 4.3 5.4 7.4 7.2 3.1 1.8 6.6 2.7 10.5 2.7 3.1 0 5.9-.6 8.4-1.7 2.6-1.1 4.8-2.8 6.6-4.9l-6.7-6.7c-1.1 1.2-2.3 2-3.6 2.7-1.4.6-2.9.9-4.7.9-1.9 0-3.6-.4-5.1-1.3-1.5-.9-2.7-2.1-3.5-3.6-.8-1.5-1.3-3.3-1.3-5.3s.4-3.8 1.3-5.3c.9-1.9 2.1-3.1 3.6-3.9zM355 111.8c-2.2-1.2-4.8-1.9-7.7-1.9s-5.5.6-7.8 1.9c-1.2.7-2.3 1.5-3.2 2.4V91.7H326V149h10.4v-22c0-1.5.3-2.8 1-4 .7-1.2 1.6-2.1 2.7-2.7 1.2-.6 2.5-.9 4-.9 2.2 0 4 .7 5.5 2.1 1.4 1.4 2.1 3.3 2.1 5.5v22h10.5v-24.3c0-2.9-.6-5.5-1.9-7.7-1.3-2.2-3.1-3.9-5.3-5.2zM399 112.5c-3.1-1.7-6.6-2.6-10.5-2.6-3.9 0-7.3.9-10.4 2.7-3.1 1.8-5.5 4.1-7.3 7.1-1.8 3-2.7 6.4-2.7 10.1 0 3.8.9 7.2 2.7 10.3 1.8 3 4.2 5.4 7.3 7.2 3.1 1.8 6.6 2.7 10.4 2.7 3.9 0 7.4-.9 10.5-2.7 3.1-1.8 5.6-4.2 7.4-7.3 1.8-3.1 2.7-6.5 2.7-10.2 0-3.8-.9-7.1-2.7-10.1-1.9-3.1-4.3-5.4-7.4-7.2zm-1.9 22.7c-.8 1.5-2 2.7-3.5 3.6-1.5.9-3.2 1.3-5.2 1.3-1.9 0-3.6-.4-5.1-1.3-1.5-.9-2.6-2.1-3.4-3.6-.8-1.5-1.2-3.3-1.2-5.3s.4-3.8 1.2-5.3c.8-1.5 2-2.7 3.4-3.6 1.5-.9 3.2-1.3 5.1-1.3 2 0 3.7.4 5.1 1.3 1.5.9 2.6 2.1 3.5 3.6.9 1.5 1.3 3.3 1.3 5.3.1 2-.3 3.8-1.2 5.3zM415.7 91.7h10.4V149h-10.4zM462.3 114.4c-1.1-1.1-2.3-2-3.7-2.8-2.2-1.1-4.6-1.7-7.3-1.7-3.5 0-6.7.9-9.5 2.6-2.8 1.7-5 4.1-6.5 7.1-1.6 3-2.4 6.4-2.4 10.2 0 3.8.8 7.1 2.4 10.1 1.6 3 3.8 5.4 6.5 7.1 2.8 1.7 5.9 2.6 9.4 2.6 2.7 0 5.2-.6 7.4-1.7 1.4-.7 2.6-1.6 3.7-2.7v3.6h10.5v-38.3h-10.5v3.9zm-2.1 22.9c-1.8 2-4.2 2.9-7.1 2.9-1.9 0-3.5-.4-5-1.3s-2.6-2.1-3.4-3.6-1.2-3.3-1.2-5.4c0-2 .4-3.8 1.2-5.3.8-1.5 2-2.7 3.4-3.6 1.5-.9 3.1-1.3 5-1.3 2 0 3.6.4 5.1 1.3 1.4.9 2.6 2.1 3.4 3.7.8 1.6 1.3 3.4 1.3 5.4 0 2.8-.9 5.3-2.7 7.2zM507.1 110.9c-1.5-.6-3.1-.9-5-.9-4.3 0-7.6 1.4-9.8 4.1l-.1.1v-3.4h-10.4v38.3h10.4V128c0-2.9.7-5 2.1-6.4 1.4-1.4 3.2-2.1 5.4-2.1 1.1 0 2 .1 2.8.4.8.3 1.5.8 2.1 1.5l6.5-7.5c-1.2-1.4-2.5-2.4-4-3z"
              />
              <path
                className="st1"
                d="M533.6 150.9c-2.3 0-4.4-.3-6.4-.8s-3.8-1.3-5.4-2.4c-1.6-1.1-3.1-2.4-4.3-4-1.2-1.6-2.1-3.4-2.8-5.6.4.1.7.2 1.1.4.3.2.6.4.8.6.2.2.4.5.4.8l-2.9 10.2h-3.7l2.7-16h3.6c.6 2.3 1.4 4.2 2.4 5.9 1 1.7 2.2 3 3.6 4.1 1.4 1.1 2.9 1.9 4.6 2.4 1.7.5 3.5.8 5.4.8 2.1 0 3.9-.4 5.3-1.1 1.4-.7 2.5-1.7 3.2-2.9.7-1.2 1.1-2.7 1.1-4.3 0-1.3-.3-2.5-.9-3.5-.6-1-1.5-1.9-2.5-2.8-1.1-.8-2.3-1.6-3.8-2.4-1.4-.8-3-1.5-4.6-2.3-2.4-1.2-4.6-2.5-6.6-3.9s-3.5-3.1-4.6-5c-1.1-2-1.7-4.3-1.7-7.1 0-2.9.7-5.5 2.1-7.7 1.4-2.2 3.4-3.9 6-5.2 2.6-1.3 5.7-1.9 9.4-1.9 2.5 0 4.7.4 6.8 1.2 2.1.8 3.9 2 5.4 3.7 1.5 1.6 2.7 3.7 3.4 6.3-.4 0-.8-.1-1.2-.3-.4-.1-.7-.4-.9-.7-.2-.3-.4-.7-.6-1.1l2.5-8.3h3.5l-2.3 13.5h-3.4c-.4-2.2-1.3-4.1-2.4-5.7-1.2-1.6-2.6-2.9-4.4-3.7-1.7-.9-3.7-1.3-5.9-1.3-2 0-3.6.3-4.9 1s-2.2 1.6-2.9 2.7c-.7 1.2-1 2.5-1 3.9 0 1.3.3 2.4.8 3.3.6 1 1.4 1.8 2.4 2.6s2.2 1.5 3.6 2.2l4.4 2.2c1.8.9 3.6 1.8 5.2 2.8 1.7 1 3.2 2.1 4.5 3.4 1.3 1.3 2.3 2.7 3.1 4.3.7 1.6 1.1 3.4 1.1 5.5 0 2.5-.5 4.7-1.4 6.7-.9 2-2.2 3.7-3.8 5.1-1.6 1.4-3.6 2.5-5.8 3.2-2.1.8-4.6 1.2-7.3 1.2zM559.2 142.9c0-.5 0-1 .1-1.5s.2-1.2.3-1.8c.1-.7.3-1.4.4-2.3l3.5-19.5c.1-.6 0-1.1-.2-1.4-.2-.3-.7-.6-1.2-.8-.6-.2-1.3-.4-2.2-.6l-.9-.1.5-2.8h16l-5.1 28.2c-.1.6-.2 1.2-.3 1.7-.1.5-.1 1-.2 1.5s-.1.9-.1 1.2c0 .8.2 1.3.6 1.7.4.3 1 .5 1.7.5.6 0 1.2-.1 1.7-.3l1.5-.6c.5-.2.8-.4 1.1-.6l-.6 2.9c-.5.4-1.2.8-2 1.2-.8.4-1.8.7-2.8 1-1 .2-2.1.4-3.3.4-1.7 0-3.2-.3-4.5-.9-1.3-.6-2.4-1.5-3.1-2.6-.6-1.2-.9-2.7-.9-4.5zm5.9-43.1c0-1.7.6-3.1 1.8-4 1.2-1 2.7-1.5 4.6-1.5s3.4.5 4.6 1.4c1.2 1 1.7 2.3 1.7 4 0 1.8-.6 3.1-1.7 4.1-1.2 1-2.7 1.5-4.7 1.5-1.9 0-3.4-.5-4.6-1.5-1.1-.9-1.7-2.3-1.7-4zM608 97.8c-1.5 0-2.7.3-3.8.9-1 .6-1.9 1.5-2.5 2.8-.7 1.3-1.2 2.9-1.5 5l-10.5 60.1h-9.1l8.1-57.9c.5-3.3 1.6-6.1 3.4-8.2 1.8-2.1 3.9-3.7 6.6-4.6 2.6-1 5.4-1.5 8.5-1.5 1 0 1.9 0 2.8.1.9.1 1.7.2 2.5.4s1.5.4 2.1.8l-.7 3.7c-.7-.4-1.5-.8-2.5-1.1-1-.3-2.1-.5-3.4-.5zM582.1 112h44.1l-.6 3.2h-44.1l.6-3.2z"
              />
              <path
                className="st1"
                d="M624.7 150.9c-2.2 0-4.1-.3-5.8-1-1.7-.6-3.1-1.7-4.1-3.1-1-1.4-1.5-3.3-1.5-5.6 0-1 .1-2 .2-3.2.1-1.2.3-2.4.6-3.6l3.6-20.8 2.3-1.5h17.6l-.6 3.2h-24.7l.6-2.8h.1c1.3 0 2.5-.1 3.4-.4.9-.3 1.7-.8 2.4-1.5.6-.7 1.2-1.7 1.6-3.1l1.6-5.4h8.8l-5.9 33.7c-.1.9-.3 1.8-.4 2.7-.1.9-.2 1.6-.3 2.4-.1.7-.1 1.4-.1 2 0 1.5.4 2.6 1.1 3.3.7.7 1.7 1 3.1 1 .7 0 1.4-.1 2.1-.3.6-.2 1.2-.4 1.7-.7.5-.3.9-.5 1.2-.7l-.5 3.2c-.7.5-1.8 1-3.2 1.5-1.5.4-3.1.7-4.9.7z"
              />
            </svg>
            <>
              <div id="google-sign-in"></div>

              <div onClick={msftClick} className="msft-signin-item">
                <img
                  src="/ms-symbol.png"
                  alt={"Sign " + (createMode ? "up" : "in") + " with microsoft"}
                  onClick={msftClick}
                />
                <span>Sign {createMode ? "up" : "in"} with Microsoft</span>
              </div>
              <ScholarSiftLogin
                email={location && location.state ? location.state.email : undefined}
                finishLogin={finishLogin}
                showLoader={showLoader}
                setError={setError}
                msftClick={msftClick}
                createMode={createMode}
                setCreateMode={setCreateMode}
              />
            </>
          </div>
        </div>
      </div>
    </ViewPort>
  );
};

export default SignIn;
